import React from 'react';

export default function DeployEditor() {
	return <button data-icon={'\uf10b'}>
		Webseite Ausbauen
	</button>
}